import React from "react";
import { BadgeCheck } from "lucide-react";
import Reveal from "./Reveal";

export function BrandStory() {
  return (
    <section id="about" className="py-24 px-6 md:px-10">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
        <Reveal>
          <div className="relative rounded-2xl overflow-hidden h-96">
            <img
              src="https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=900&q=80&auto=format&fit=crop"
              alt="Marque studio"
              className="absolute inset-0 w-full h-full"
              style={{ objectFit: "cover" }}
              loading="lazy"
            />
            <div
              className="absolute inset-0"
              style={{ background: "linear-gradient(180deg, rgba(11,14,19,0) 40%, rgba(11,14,19,0.7) 100%)" }}
            ></div>
          </div>
        </Reveal>
        <div>
          <Reveal>
            <p className="uppercase tracking-widest text-xs mb-3" style={{ fontFamily: "'JetBrains Mono', monospace", color: "#1E9AFF" }}>
              Our Story
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 style={{ fontFamily: "Fraunces, serif" }} className="text-3xl md:text-4xl text-white mb-6">
              We started BBS because good taste shouldn't need twelve tabs open
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="text-sm md:text-base leading-relaxed mb-4" style={{ color: "rgba(245,241,234,0.65)" }}>
              Twelve years ago, our founders were tired of hopping between a dozen brand
              sites just to build one outfit. BBS brings 120+ labels, verified for
              authenticity, into a single, calm shopping experience.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <p className="text-sm md:text-base leading-relaxed mb-8" style={{ color: "rgba(245,241,234,0.65)" }}>
              Every piece is checked by our in-house team before it ships — so you can
              shop across brands with the same trust you'd give a single boutique.
            </p>
          </Reveal>
          <Reveal delay={0.4}>
            <div className="flex items-center gap-3">
              <BadgeCheck size={20} color="#1E9AFF" />
              <span className="text-sm uppercase tracking-widest text-white opacity-80">
                Authenticated by BBS since 2014
              </span>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

export default BrandStory;
